import { eventBus } from 'EventBus/';
import productEbsStore from '../../stores/productEbs/productEbs';

export const busName = 'variantSelector';

export const handleShadeSelection = (shadeDescription) => {
  if (!shadeDescription) return;
  document.getElementById('current-shade').innerText = shadeDescription;
};

export const publishVariantSelectionEvent = (
  productEAN,
  productItemId,
  varintItemId
) => {
  if (!productEAN) return;
  eventBus.$emit(`${busName}::selected`, productEAN);
  window.eventBus.$emit('rfp-mctb-has-variant-component', {
    productItemId: productItemId.toUpperCase(),
    varintItemId: varintItemId.toUpperCase(),
  });
  // modifying Refapp analytics events product-id to use productEAN that is stored within variant
  window.eventBus.$emit('rfp-product-variant-data-update', {
    ean: productEAN,
  });
};

export const variantSelector = {
  name: 'vch-variant-selector',
  inserted: (el, binding, vnode) => {

    //get ebs enabled and loaded state from store
    let store = vnode.context.$store;
    if (!store.hasModule('productEbs')) {
      store.registerModule('productEbs', productEbsStore);
    }

    if (el.tagName === 'INPUT') {
      el.addEventListener('change', () => {
        
        let isEbsEnabled = store?.state?.productEbs?.isEbsEnabled;
        let isEbsLoaded = store?.state?.productEbs?.isEbsLoaded;

        handleShadeSelection(binding.value?.shade);
        publishVariantSelectionEvent(
          binding.value?.ean,
          binding.value?.productItemId,
          binding.value?.varintItemId
        );
        if(isEbsEnabled && isEbsLoaded && typeof window.RefApp?.DSF?.SetEANNumber === 'function') {
          let dataEan = binding.value?.ean;
          window.RefApp.DSF.SetEANNumber(dataEan);
        }
      });
    }
  },
};
